<template>
  <div class="copyright">
    <span><a href="http://www.beian.miit.gov.cn/" target="_blank">{{ beian }}</a></span>
    <span>由 www.zoosoft.cn 提供技术支持. Ver:{{ ver }} Build:{{ build }}</span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      beian: this.$appCfg.tenant_beian || '',
      ver: process.env.VUE_APP_WEB_VERSION || '',
      build: process.env.VUE_APP_BUILD_VERSION || ''
    }
  }
}
</script>

<style scoped>
.copyright{
  display: flex;
  flex-direction: column;
  font-size:.625rem;
  line-height:.625rem;
  text-align: center;
  position: absolute;
  width: calc(100vw - var(--mp) * 2);
}
.copyright > span {
  margin: 8px;
  color: #c0c0c0;
}
.copyright  a:link, .copyright  a:visited,  .copyright  a:hover,  .copyright  a:active {
  color: #c0c0c0;
}

@supports (bottom: constant(safe-area-inset-bottom)) or (bottom: env(safe-area-inset-bottom)) {
  .copyright{
    bottom: calc(var(--mp) + constant(safe-area-inset-bottom)) ;
    bottom: calc(var(--mp) + env(safe-area-inset-bottom));
  }
}
</style>
